export const UPDATE_USER_DIRECTION= "UPDATE_USER_DIRECTION";
export const UPDATE_MOUSE_DIRECTION = "UPDATE_MOUSE_DIRECTION";

export const DIRECTIONS = {NONE:"NONE", UP: "UP", DOWN: "DOWN", LEFT:"LEFT", RIGHT:"RIGHT"}